__turbopack_context__.v({
  "blueprintCards": "index-module__n-UXLW__blueprintCards",
  "destinations": "index-module__n-UXLW__destinations",
  "divider": "index-module__n-UXLW__divider",
  "loading": "index-module__n-UXLW__loading",
  "mainContent": "index-module__n-UXLW__mainContent",
  "messagePanel": "index-module__n-UXLW__messagePanel",
  "messagePanelOpen": "index-module__n-UXLW__messagePanelOpen",
  "title": "index-module__n-UXLW__title",
});
